module.exports = __webpack_public_path__ + "assets/img/9.4730d338.png";